import { SanitizedText } from '../index.js';

export type BannerType = {
    title: string;
    text: string;
};

const Banner = ({ banner }: { banner: BannerType }) => {
    const { title, text } = banner;
    return (
        <w-box info className="mt-32 mb-24">
            <div className="flex space-x-16">
                <div className="shrink-0">
                    <w-icon
                        name="SuccessFilled"
                        size="large"
                        style={{ color: 'var(--w-s-color-background-primary)' }}
                    />
                </div>
                <div>
                    <p className="font-bold">{title}</p>
                    <SanitizedText text={text} />
                </div>
            </div>
        </w-box>
    );
};

export default Banner;
